import React from 'react';
import { Button, Input, Label, Switch } from '@roger/ui-components';
import { Plus } from 'lucide-react';

interface GroupManagerHeaderProps {
  q: string;
  onQChange: (q: string) => void;
  showArchived: boolean;
  onShowArchivedChange: (showArchived: boolean) => void;
  onNewGroup: () => void;
}

export const GroupManagerHeader: React.FC<GroupManagerHeaderProps> = ({
  q,
  onQChange,
  showArchived,
  onShowArchivedChange,
  onNewGroup,
}) => (
  <div className='flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'>
    <h1 className='text-2xl font-semibold'>Group Manager</h1>
    <div className='flex flex-wrap items-center gap-3'>
      <Input
        inputSize='sm'
        className='w-full md:w-64'
        placeholder='Search groups'
        value={q}
        onChange={event => onQChange(event.target.value)}
      />
      <div className='flex items-center gap-2'>
        <Switch
          id='group-manager-show-archived'
          checked={showArchived}
          onCheckedChange={onShowArchivedChange}
        />
        <Label htmlFor='group-manager-show-archived'>Show archived</Label>
      </div>
      <Button onClick={onNewGroup}>
        <Plus className='h-4 w-4' />
        New group
      </Button>
    </div>
  </div>
);
